import { render, staticRenderFns } from "./viewStockDetails.vue?vue&type=template&id=2eb821d6&scoped=true"
import script from "./viewStockDetails.vue?vue&type=script&lang=js"
export * from "./viewStockDetails.vue?vue&type=script&lang=js"
import style0 from "./viewStockDetails.vue?vue&type=style&index=0&id=2eb821d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb821d6",
  null
  
)

export default component.exports